<div class="formgrid grid">

  <div class="col-12 md:col-6">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Name</h3>
    <input pInputText type="text" class="inputfield w-full" [(ngModel)]="name" placeholder="What happens now?"
      data-testid="global-block-name" />
    <small class="block text-500 mt-1">Only shown in Conductor, when you pick a global block for a page.</small>
  </div>

  <div class="col-12 md:col-6">
    <h3 class="flex-grow-1 text-500 border-bottom-1 border-200">Used on</h3>
    <p *ngIf="usedOn.length" class="m-0 text-700" data-testid="global-block-used-on">
      {{ usedOn.length }} place(s): {{ usedOnText }}
    </p>
    <p *ngIf="!usedOn.length" class="m-0 text-500">No pages yet. Add it to a page from the page's building block list.</p>
    <small class="block text-500 mt-1">A change here reaches all of them when the global block is published.</small>
  </div>

  <!-- ── Blocks ──────────────────────────────────────────────────────────── -->
  <div class="col-12">
    <div class="border-bottom-1 border-200">
      <h3 class="text-500 my-2">Blocks</h3>
    </div>
    <div class="flex gap-3 align-items-start">
      <app-content-sections-editor class="flex-1 min-w-0" mode="global"></app-content-sections-editor>
      <app-block-preview *ngIf="preview.shown" [source]="previewSource" (closed)="preview.set(false)"></app-block-preview>
    </div>
  </div>

  <!-- Sticky action bar, as on the page editor. -->
  <div class="col-12 app-editor-action-bar flex flex-wrap align-items-center justify-content-between gap-2 surface-card border-top-1 border-200 py-3"
       style="position: sticky; bottom: -1.5rem; z-index: 5; margin-bottom: -1.5rem">
    <div class="flex gap-2">
      <button pButton pRipple type="button" label="Add section" icon="pi pi-plus"
        class="p-button-outlined p-button-sm" (click)="sectionsEditor.addSection('section')"
        data-testid="global-block-add-section"></button>
      <app-block-preview-toggle></app-block-preview-toggle>
    </div>
    <span class="flex gap-2 align-items-center">
      <span *ngIf="lastSavedAt && !saving" class="text-600 text-sm white-space-nowrap">Saved {{ lastSavedAt | date: 'shortTime' }}</span>
      <button pButton pRipple type="button" label="Cancel" class="p-button-text" [disabled]="saving" (click)="onCancel()"></button>
      <button pButton pRipple type="button" label="Save" icon="pi pi-check" class="p-button-outlined"
        [loading]="saving && !closing" [disabled]="saving" (click)="onSave(false)" data-testid="global-block-save"></button>
      <button pButton pRipple type="button" label="Save & Close" icon="pi pi-check"
        [loading]="saving && closing" [disabled]="saving" (click)="onSave(true)" data-testid="global-block-save-close"></button>
    </span>
  </div>

</div>
